export default __webpack_public_path__ + "locales/hy-AM/ChangeUserTypeDialog.json?hash=65033347191cfb6778901562b8f56c96";